// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"dd853a04","977":"aaaa41e4"}[chunkId] + ".chunk.js";
};